export default function toggleBlockVisibility() {
    const hasPartenaire = document.querySelector<HTMLInputElement>('#projet_form_information_du_participant_avec_partenaire_0');
    const blockToShowHide = document.querySelector<HTMLElement>('#info-partenaire');

    if (hasPartenaire && blockToShowHide) {
        if (hasPartenaire.checked == true) {
            blockToShowHide.style.display = 'block';
        } else {
            blockToShowHide.style.display = 'none';
        }
    }

    const radioButtons = document.querySelectorAll('[id^="projet_form_information_du_participant_avec_partenaire_"]');
    radioButtons.forEach(radioButton => {
        radioButton.addEventListener('change', e => {
            const selectedValue = (e.target as HTMLInputElement).value;

            if (blockToShowHide) {
                if (selectedValue === '1') {
                    blockToShowHide.style.display = 'block';
                } else {
                    blockToShowHide.style.display = 'none';
                }
            }
        });
    });

    document.addEventListener('scroll', () => {
        const carte = document.querySelector('.sticky-card') as HTMLElement;
        const content = document.querySelector('.depot') as HTMLElement;
        const form = document.querySelector('.formulaire') as HTMLElement;
        
        if (window.scrollY >= content?.offsetTop) {
            carte?.classList.add('fixe');
        } else {
            carte?.classList.remove('fixe');
        }
        
        if (window.scrollY >= form?.offsetTop + form?.offsetHeight) {
            carte?.classList.remove('fixe');
        }
    });
    
}